import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";
import { UnitBreadcrumbsList } from "../Const";

const UnitForm = ({ edit = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}unit/get/${id}`)
      .then((response) => {
        setValue("unit", response.data.unit);
        setValue("active", response.data.active);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(`unit/update/${id}`, "PATCH", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`unit/create`, "POST", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="healthsyMasterBreadCrumbs"
                breadcrumbsList={UnitBreadcrumbsList("", edit)}
              />
              <BackBtn navigatePath="/healthsy-services/order-medicines/masters/unit" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Unit Name"
                  errorText="Please enter the Unit Name"
                  name="unit"
                  placeholder="Type here..."
                />
              </div>
              <div className="col-3">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  labelName="Status"
                />
              </div>
            </div>
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/healthsy-services/order-medicines/masters/unit"}
          name="new Unit"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default UnitForm;
